import { transformDTODate } from "@skylab-shared/core";
import { Transform, Type } from "class-transformer";
import { InventoryEffect } from "../inventory-effect";

export class InventoryStocktakingDocumentItemDTO {
	public no: number;
	public productName: string;
	public productId: number;
	public unitId: number;
	public systemQuantity: number;
	public stocktakingQuantity?: number;
	public receiptQuantity: number;
	public issueQuantity: number;
	public salePrice: number;
	public purchasePrice: number;
	public symbol: string;
	public barCode: string;
}

class InventoryStocktakingDocumentDTO {
	public version: string;
	public duplicatePreventionId: string;
	public id: number;
	public inventoryId: number;
	public documentNumber: string;
	@Transform(transformDTODate, { toClassOnly: true }) public stocktakingDate: Date;
	public preparer: string;
	public approver: string;
	public numberingId: number;
	@Type(() => InventoryStocktakingDocumentItemDTO) public items: InventoryStocktakingDocumentItemDTO[];
}

export class InventoryStocktakingGetDocumentDTO extends InventoryStocktakingDocumentDTO {
	public inventoryEffect: InventoryEffect.Deferred | InventoryEffect.Realized;
}

export class InventoryStocktakingUpdateDocumentDTO extends InventoryStocktakingDocumentDTO { }

